'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iconBase = require('../icon-base');

var _iconBase2 = _interopRequireDefault(_iconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FaQuestionCircle = function (_React$Component) {
  _inherits(FaQuestionCircle, _React$Component);

  function FaQuestionCircle() {
    _classCallCheck(this, FaQuestionCircle);

    return _possibleConstructorReturn(this, (FaQuestionCircle.__proto__ || Object.getPrototypeOf(FaQuestionCircle)).apply(this, arguments));
  }

  _createClass(FaQuestionCircle, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _iconBase2.default,
        this.props,
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { d: 'M896 1376v-192q0-14-9-23t-23-9H672q-14 0-23 9t-9 23v192q0 14 9 23t23 9h192q14 0 23-9t9-23zm256-672q0-88-55.5-163T958 425t-170-41q-243 0-371 213-15 24 8 42l132 100q7 6 19 6 16 0 25-12 53-68 86-92 34-24 86-24 48 0 85.5 26t37.5 59q0 38-20 61t-68 45q-63 28-115.5 86.5T640 1020v36q0 14 9 23t23 9h192q14 0 23-9t9-23q0-19 21.5-49.5T972 957q32-18 49-28.5t46-35 44.5-48 28-60.5 12.5-81zm384 192q0 209-103 385.5T1153.5 1561 768 1664t-385.5-103T103 1281.5 0 896t103-385.5T382.5 231 768 128t385.5 103T1433 510.5 1536 896z' })
        )
      );
    }
  }]);

  return FaQuestionCircle;
}(_react2.default.Component);

FaQuestionCircle.defaultProps = {
  viewBox: '0 0 1536 1896.0833',
  height: '1em',
  width: '0.8101em'
};

exports.default = FaQuestionCircle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-icons/lib/fa/question-circle.js
// module id = 624
// module chunks = 0 1 4